export default __webpack_public_path__ + "static/media/crypto-com.4a7f0297.svg";